/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Uno_MoveInputs */



/**
* | output |
* | --- |
* | "After this I'll move to the bottom-right corner. Whenever you have a question about oneAI, you'll find me there." |
*
* @param {Onboarding_Uno_MoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_uno_move = /** @type {((inputs?: Onboarding_Uno_MoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Uno_MoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Danach rücke ich in die Ecke unten rechts. Wann immer du eine Frage zu oneAI hast, findest du mich dort.")
	return /** @type {LocalizedString} */ ("After this I'll move to the bottom-right corner. Whenever you have a question about oneAI, you'll find me there.")
});